import { EPricesFiltersPeriod } from '../../../types/realtyValuation';

const postfixes: Record<EPricesFiltersPeriod, string> = {
  [EPricesFiltersPeriod.AllTime]: 'все время',
  [EPricesFiltersPeriod.Year]: 'год',
  [EPricesFiltersPeriod.HalfYear]: 'полгода',
};

export const getPriceDiffTitle = (period: EPricesFiltersPeriod = EPricesFiltersPeriod.AllTime) =>
  `Изменение цены м² за ${postfixes[period]}`;
